"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessagingClient = void 0;
const api_1 = require("../core/api");
/**
 * Client that contains messaging and notifications related operations
 */
class MessagingClient {
    constructor(config) {
        this.config = config;
        this.api = new api_1.ApiService(config);
    }
    /**
     * Fetch channels by provided query
     * @param query @type Query
     */
    findChannels(query) {
        const { api } = this;
        return api.get(["channels"], query);
    }
    /**
     * Fetch channel by id
     * @param channelId @type string
     */
    findChannel(channelId) {
        const { api } = this;
        return api.get(["channels", channelId]);
    }
    /**
     * Fetch channel's members
     * @param channelId @type string
     */
    getMembers(channelId) {
        const { api } = this;
        return api.get(["channels", channelId, "members"]);
    }
    /**
     * Create new channel
     * @param body @type Channel
     */
    createChannel(body) {
        const { api } = this;
        return api.post(["channels"], body);
    }
    /**
     * Insert new message in the channel
     * @param channelId @type string
     * @param body @type ChannelMessage
     */
    insertMessage(channelId, body) {
        const { api } = this;
        return api.post(["channels", channelId, "messages"], body);
    }
    /**
     * Fetch messages from specified channel and query expression
     * @param channelId @type string
     * @param query @type Query
     */
    getMessages(channelId, query) {
        const { api } = this;
        return api.get(["channels", channelId, "messages"], query);
    }
    /**
     * Fetch message from specified channel and messageId
     * @param channelId @type string
     * @param messageId @type string
     */
    getMessage(channelId, messageId) {
        const { api } = this;
        return api.get(["channels", channelId, "messages", messageId]);
    }
    /**
     * Fetch unread messages for specified channel and user
     * @param channelId @type string
     * @param userId @type string
     */
    getUnreadMessages(channelId, userId) {
        const { api } = this;
        return api.get(["channels", channelId, "users", userId, "messages", "unread"]);
    }
    /**
     * Mark messages as read for the specified channel and user
     * @param channelId @type string
     * @param userId @type string
     * @param body @type MarkMessagesAsRead
     */
    markMessagesAsRead(channelId, userId, body) {
        const { api } = this;
        return api.post(["channels", channelId, "users", userId, "messages", "mark", "read"], body);
    }
    /**
     * Assign members to specified channel
     * @param channelId @type string
     * @param body @type MembersDto
     */
    assignMembers(channelId, body) {
        const { api } = this;
        return api.post(["channels", channelId, "members"], body);
    }
    /**
     * Update member of the channel
     * @param channelId @type string
     * @param memberId @type string
     * @param body @type Member
     */
    updateMember(channelId, memberId, body) {
        const { api } = this;
        return api.put(["channels", channelId, "members", memberId], body);
    }
    /**
     * Delete member from the channel
     * @param channelId @type string
     * @param memberId @type string
     */
    removeMember(channelId, memberId) {
        const { api } = this;
        return api.delete(["channels", channelId, "members", memberId]);
    }
}
exports.MessagingClient = MessagingClient;
//# sourceMappingURL=messaging.client.js.map